/**
 * Detect fn
 */
export default () =>
  'document' in self && 'hidden' in document && 'visibilityState' in document
